export default "__VITE_ASSET__cd210027__"